/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_LifetimeInputs */

const cs_projects_lifetime = /** @type {(inputs: Projects_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doba zveřejnění`)
};

const en_projects_lifetime = /** @type {(inputs: Projects_LifetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing lifetime`)
};

/**
* | output |
* | --- |
* | "Listing lifetime" |
*
* @param {Projects_LifetimeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_lifetime = /** @type {((inputs?: Projects_LifetimeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_LifetimeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_lifetime(inputs)
	return cs_projects_lifetime(inputs)
});